<!--
 * @Author: your name
 * @Date: 2020-09-23 15:53:04
 * @LastEditTime: 2020-09-23 16:40:38
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \Web\JiYun.Mobile\src\views\salesTerminal\statisticalAnalysis\accountsReceive\accumulativeTotal.vue
-->
<template>
    <div class="accumulativeTotal">
        <ul>
            <li>
                <h4>{{ totalData.loans_receivable }}</h4>
                <p>
                    <span class="iconfont iconyingshou"></span>
                    <span>总累计应收(万元)</span>
                </p>
            </li>
            <li>
                <h4>{{ totalData.official_receipt }}</h4>
                <p>
                    <span class="iconfont iconjine"></span>
                    <span>总累计实收(万元)</span>
                </p>
            </li>
            <li>
                <h4>{{ totalData.ending_balance_receivable }}</h4>
                <p>
                    <span class="iconfont iconjine1"></span>
                    <span>总应收账款余额(万元)</span>
                </p>
            </li>
            <li>
                <h4>{{ totalData.overdue_arrears }}</h4>
                <p>
                    <span class="iconfont iconzhangdan"></span>
                    <span>总逾期账款(万元)</span>
                </p>
            </li>
            <li>
                <h4>{{ totalData.balance_receivable_rate }}%</h4>
                <p>
                    <span class="iconfont icontongji1"></span>
                    <span>总回款率(%)</span>
                </p>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    components: {},
    props: {},
    data() {
        return {
            totalData: {},
        };
    },
    watch: {},
    computed: {},
    created() {},
    mounted() {
        this.handleTotal();
    },
    methods: {
        // 处理全部合同应收
        async handleTotal() {
            const res = await this.getTotal();
            if (res) {
                if (res.loans_receivable) {
                    res.loans_receivable = (res.loans_receivable / 10000).toFixed(2);
                }
                if (res.official_receipt) {
                    res.official_receipt = (res.official_receipt / 10000).toFixed(2);
                }
                if (res.overdue_arrears) {
                    res.overdue_arrears = (res.overdue_arrears / 10000).toFixed(2);
                }
                if (res.ending_balance_receivable) {
                    res.ending_balance_receivable = (res.ending_balance_receivable / 10000).toFixed(2);
                }
                this.totalData = res;
            }
        },
        // 获取全部合同应收
        getTotal() {
            const path = '/interfaceApi/sale/accounts/receivable_total';
            return this.$axios.$get(path, { defEx: true });
        },
    },
};
</script>
<style lang="stylus">
.accumulativeTotal
    height 100%
    overflow-y auto
    padding 15rpx
    li
        height 100rpx
        background-size 100% 100%
        background-repeat no-repeat
        padding 18rpx 0 0 30rpx
        margin-bottom 15rpx
        h4
            font-size 32rpx
            color #fff
            margin-bottom 5rpx
        p
            font-size 14rpx
            color #fff
            line-height 18rpx
            // .iconfont
            //     font-size 13rpx
            span
                display inline-block
                vertical-align middle
                margin-right 5rpx
        &:nth-child(1)
            background-image url(./../images/bg1.png)
        &:nth-child(2)
            background-image url(./../images/bg2.png)
        &:nth-child(3)
            background-image url(./../images/bg3.png)
        &:nth-child(4)
            background-image url(./../images/bg4.png)
        &:nth-child(5)
            background-image url(./../images/bg5.png)
</style>